import { render, staticRenderFns } from "./ProjectManagement.vue?vue&type=template&id=4e1e2024&scoped=true&"
import script from "./ProjectManagement.vue?vue&type=script&lang=js&"
export * from "./ProjectManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManagement.vue?vue&type=style&index=0&id=4e1e2024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e2024",
  null
  
)

export default component.exports